import { ShieldCheck, CheckCircle, Award, Users, Target, TrendingUp, Sparkles } from "lucide-react";
import About1 from "../assests/about/about.jpg";
import About2 from "../assests/about/about2.jpg";
import About3 from "../assests/about/about2.jpg";
import CTA from "./CTA";

const About = () => {
    return (
        <div className="pt-20 bg-gradient-to-b from-white to-gray-50">

            {/* ================= BANNER SECTION ================= */}
            <section className="relative h-[60vh] lg:h-[70vh] overflow-hidden">
                <div className="absolute inset-0 grid grid-cols-3">
                    <img src={About1} alt="Construction work" className="h-full w-full object-cover transform hover:scale-105 transition-transform duration-700" />
                    <img src={About2} alt="Building site" className="h-full w-full object-cover transform hover:scale-105 transition-transform duration-700" />
                    <img src={About3} alt="Professional team" className="h-full w-full object-cover transform hover:scale-105 transition-transform duration-700" />
                </div>

                {/* Animated Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>

                {/* Animated Dots Pattern */}
                <div className="absolute inset-0 opacity-10" style={{
                    backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
                    backgroundSize: '30px 30px'
                }}></div>

                {/* Content */}
                <div className="relative z-10 h-full flex items-center justify-center text-center px-4">
                    <div className="max-w-4xl">
                        <h1 className="text-4xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
                            About <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F57C00] to-orange-400">We United</span> Constructions Ltd
                        </h1>
                        <p className="text-xl text-gray-200 max-w-2xl mx-auto mb-8">
                            Your trusted partner in delivering exceptional construction solutions across the United Kingdom
                        </p>
                        <div className="flex justify-center gap-3">
                            <div className="h-1.5 w-16 bg-[#F57C00] rounded-full"></div>
                            <div className="h-1.5 w-16 bg-[#0B3C8A] rounded-full"></div>
                            <div className="h-1.5 w-16 bg-[#F57C00] rounded-full"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ================= STATS SECTION ================= */}
            <section className="relative -mt-12 z-20">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        {[
                            { icon: Award, label: "Projects Completed", value: "500+", color: "from-blue-500 to-blue-600" },
                            { icon: Users, label: "Happy Clients", value: "350+", color: "from-orange-500 to-orange-600" },
                            { icon: Target, label: "Success Rate", value: "98%", color: "from-blue-500 to-blue-600" },
                            { icon: TrendingUp, label: "Years Experience", value: "25+", color: "from-orange-500 to-orange-600" },
                        ].map((stat, index) => (
                            <div
                                key={index}
                                className="group relative bg-white rounded-xl p-4 md:p-5 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 overflow-hidden"
                            >
                                {/* subtle corner blob */}
                                <div className="absolute top-0 right-0 w-24 h-24 bg-gray-100 rounded-full -mr-12 -mt-12 group-hover:scale-125 transition-transform duration-500"></div>

                                <div className="relative">
                                    {/* icon */}
                                    <div
                                        className={`w-10 h-10 md:w-11 md:h-11 rounded-lg bg-gradient-to-br ${stat.color}
              flex items-center justify-center shadow group-hover:scale-105 transition-all duration-300`}
                                    >
                                        <stat.icon className="text-white" size={18} strokeWidth={2.2} />
                                    </div>

                                    {/* value */}
                                    <div className="mt-3 text-2xl md:text-3xl font-bold text-gray-800 leading-tight">
                                        {stat.value}
                                    </div>

                                    {/* label */}
                                    <div className="text-xs md:text-sm font-medium text-gray-600">
                                        {stat.label}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= ABOUT CONTENT ================= */}
            <section className="bg-white py-10 lg:py-10 mt-16">
                <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">

                    {/* TEXT */}
                    <div className="space-y-7 text-center lg:text-left">
                        {/* Badge */}
                        <div className="inline-flex items-center gap-2 px-5 py-2 bg-blue-50 rounded-full shadow-sm mx-auto lg:mx-0">
                            <Sparkles className="text-[#0B3C8A]" size={16} />
                            <span className="text-[#0B3C8A] font-semibold text-sm tracking-wide">
                                Who We Are
                            </span>
                        </div>

                        {/* Heading */}
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#082C5A] leading-tight">
                            Building Trust Through{" "}
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F57C00] to-orange-500">
                                Quality & Excellence
                            </span>
                        </h2>

                        {/* Divider */}
                        <div className="w-24 h-1.5 bg-gradient-to-r from-[#F57C00] to-orange-400 rounded-full mx-auto lg:mx-0"></div>

                        {/* Paragraphs */}
                        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                            We United Constructions Ltd was established to deliver reliable,
                            professional, and high-quality construction services throughout
                            the United Kingdom. Our reputation is built on trust, strong
                            workmanship, attention to detail, and a customer-focused approach.
                        </p>

                        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
                            We work across residential, commercial, and civil sectors,
                            providing complete construction solutions tailored to each
                            client's requirements. Our team consists of skilled tradespeople,
                            experienced site supervisors, and project managers who ensure
                            every project is delivered efficiently and to a high standard.
                        </p>

                        {/* Badges */}
                        <div className="flex flex-wrap gap-3 pt-4 justify-center lg:justify-start">
                            {[
                                "Licensed & Insured",
                                "UK Certified",
                                "Quality Assured",
                            ].map((item, index) => (
                                <div
                                    key={index}
                                    className="flex items-center gap-2 px-4 py-2 bg-gray-50 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition"
                                >
                                    <CheckCircle className="text-[#F57C00]" size={18} />
                                    <span className="text-gray-700 font-medium text-sm">
                                        {item}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>


                    {/* IMAGE */}
                    <div className="relative group">
                        {/* Glow background */}
                        <div className="absolute -inset-8 bg-gradient-to-br from-[#0B3C8A]/15 to-[#F57C00]/15 rounded-3xl blur-3xl opacity-80 group-hover:opacity-100 transition duration-500"></div>

                        <div className="relative">
                            {/* Accent shapes */}
                            <div className="absolute -top-6 -right-6 w-28 h-28 bg-gradient-to-br from-[#F57C00] to-orange-500 rounded-2xl opacity-20 group-hover:scale-110 transition-transform duration-500"></div>
                            <div className="absolute -bottom-6 -left-6 w-36 h-36 bg-gradient-to-br from-[#0B3C8A] to-blue-600 rounded-2xl opacity-20 group-hover:scale-110 transition-transform duration-500"></div>

                            {/* Image */}
                            <img
                                src={About2}
                                alt="Construction excellence"
                                className="relative rounded-2xl shadow-2xl w-full h-[360px] md:h-[420px] lg:h-[460px] object-cover group-hover:scale-[1.03] transition-transform duration-500"
                            />
                        </div>
                    </div>

                </div>
            </section>


            {/* ================= HEALTH & SAFETY ================= */}
            <section
                className="relative py-20 lg:py-28 overflow-hidden bg-cover bg-center"
                style={{
                    backgroundImage:
                        "url(https://images.unsplash.com/photo-1581093458791-9d15482778a1?auto=format&fit=crop&w=1600&q=80)",
                }}
            >
                {/* Dark Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#0B3C8A]/90 via-[#0B3C8A]/80 to-black/80"></div>

                {/* Subtle Pattern */}
                <div
                    className="absolute inset-0 opacity-10"
                    style={{
                        backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
                        backgroundSize: "40px 40px",
                    }}
                ></div>

                {/* Glow accents */}
                <div className="absolute top-10 right-10 w-72 h-72 bg-[#F57C00]/20 rounded-full blur-3xl hidden lg:block"></div>
                <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl hidden lg:block"></div>

                {/* CONTENT */}
                <div className="relative max-w-6xl mx-auto px-4 text-center text-white">

                    {/* ICON */}
                    <div className="flex justify-center mb-8">
                        <div className="relative">
                            <div className="absolute -inset-4 bg-white/20 rounded-2xl blur-xl"></div>
                            <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-white flex items-center justify-center shadow-2xl">
                                <ShieldCheck className="text-[#0B3C8A]" size={36} strokeWidth={2.5} />
                            </div>
                        </div>
                    </div>

                    {/* HEADING */}
                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                        Health & Safety <span className="text-[#F57C00]">Commitment</span>
                    </h2>

                    {/* DIVIDER */}
                    <div className="flex justify-center gap-3 mb-8">
                        <div className="h-1.5 w-12 sm:w-16 bg-[#F57C00] rounded-full"></div>
                        <div className="h-1.5 w-12 sm:w-16 bg-white/40 rounded-full"></div>
                        <div className="h-1.5 w-12 sm:w-16 bg-[#F57C00] rounded-full"></div>
                    </div>

                    {/* TEXT */}
                    <p className="text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed max-w-4xl mx-auto mb-12">
                        Health and safety is central to our operations. We work in accordance
                        with the Health and Safety at Work Act and the Construction (Design
                        and Management) Regulations, ensuring safe working environments for
                        our team, clients, and the public at all times.
                    </p>

                    {/* INFO CARDS */}
                    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
                        {[
                            { title: "Certified Standards", desc: "Full UK compliance" },
                            { title: "Regular Training", desc: "Team safety updates" },
                            { title: "Risk Assessment", desc: "Every project evaluated" },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white/10 backdrop-blur-md rounded-xl p-5 sm:p-6 border border-white/20 hover:bg-white/20 transition-all duration-300"
                            >
                                <div className="text-[#F57C00] font-semibold text-lg mb-1">
                                    {item.title}
                                </div>
                                <div className="text-gray-300 text-sm">
                                    {item.desc}
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            {/* ================= WHY CHOOSE US ================= */}
            <section className="bg-gradient-to-b from-white to-gray-50 py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="text-center mb-16">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-50 rounded-full mb-4">
                            <Award className="text-[#F57C00]" size={18} />
                            <span className="text-[#F57C00] font-semibold text-sm">Our Advantages</span>
                        </div>

                        <h2 className="text-4xl lg:text-5xl font-bold text-[#082C5A] mb-6">
                            Why Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F57C00] to-orange-500">Us</span>
                        </h2>

                        <div className="flex justify-center gap-3">
                            <div className="h-1.5 w-16 bg-[#F57C00] rounded-full"></div>
                            <div className="h-1.5 w-16 bg-[#0B3C8A] rounded-full"></div>
                            <div className="h-1.5 w-16 bg-[#F57C00] rounded-full"></div>
                        </div>
                    </div>

                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {[
                            "Experienced UK-based construction professionals",
                            "High standards of workmanship and materials",
                            "Transparent pricing and clear communication",
                            "Full compliance with UK regulations",
                            "Projects delivered on time and to specification",
                            "24/7 customer support and guidance",
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="group relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 overflow-hidden"
                            >
                                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-orange-50 to-transparent rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-700"></div>
                                <div className="relative flex items-start gap-4">
                                    <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-[#F57C00] to-orange-600 flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                                        <CheckCircle className="text-white" size={24} strokeWidth={2.5} />
                                    </div>
                                    <p className="text-gray-700 font-semibold leading-relaxed pt-2">
                                        {item}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        <CTA />
        </div>
    );
};

export default About;